export default __webpack_public_path__ + "static/media/referral_small.42eb7616.png";